import { useCallback, useEffect, useRef, useState } from 'react';

const initialParams = {
  search: '',
  page: 1,
  sortOrder: 'asc',
};

const usePagination = ({ service, itemsPerPage = 5, sortByFiled = 'email' }) => {
  const [list, setList] = useState([]);
  const [query, setQuery] = useState({ ...initialParams, perPage: itemsPerPage, sortBy: sortByFiled });
  const [totalData, setTotalData] = useState(0);

  const [isLoading, setIsLoading] = useState(true);
  const [isEmptyList, setEmptyList] = useState(true);
  const [init, setInit] = useState(false);

  const onSearch = useCallback(value => setQuery({ ...query, search: value.trim(), page: 1 }), [query]);
  const onChangeFilter = useCallback(value => setQuery({ ...query, filter: value, page: 1 }), [query]);
  const onChangePage = useCallback(value => setQuery({ ...query, page: value }), [query]);
  const onSort = useCallback(({ sortBy, sortOrder }) => setQuery({ ...query, sortBy, sortOrder }), [query]);
  const onResetQuery = useCallback(() => setQuery({ ...initialParams, perPage: itemsPerPage, sortBy: sortByFiled }), [
    itemsPerPage,
    sortByFiled,
  ]);

  const loadList = async (isIgnoreLoading = false) => {
    if (!isIgnoreLoading) {
      setIsLoading(true);
    }

    try {
      const content = await service(query);
      setTotalData(content?.meta?.total);
      setList(content?.data || []);

      if (!content?.data?.length && query.searchTerm === '') {
        setEmptyList(true);
      } else {
        setEmptyList(false);
      }
    } catch (e) {
      console.log('Pagination error', e.message);
    }
    setInit(true);
    setIsLoading(false);
  };

  useEffect(() => {
    init && loadList();
  }, [service, query]);

  useEffect(() => {
    loadList();
  }, []);

  return {
    list,
    query,
    totalData,
    isLoading,
    isEmptyList,
    onSearch,
    onChangeFilter,
    onChangePage,
    onSort,
    loadList,
    onResetQuery,
  };
};

export default usePagination;
